/// Port of mobile/lib/features/game/engine/audio/audio_constants.dart.

/** Max BGM output = slider × this (0.1 keeps the hot master track in the background). */
export const musicMaxGain = 0.1;

export const defaultMusicVolume = 0.4;
export const defaultSfxVolume = 1.0;
